<div class="container">
  <div class="headerContainer">
    <h1><b>User Admin</b></h1>
  </div>

  <div class="buttonSection">
    <button mat-fab extended class="warn" id="addNewUserButton" (click)="addNewUser()">
      <mat-icon>person_add</mat-icon>
      ADD NEW USER
    </button>
  </div>

  <div class="content">
    <ag-grid-angular
      style="width: 100%; height: 70vh"
      [rowData]="rowData"
      [columnDefs]="colDefs"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      (gridReady)="onGridReady($event)"
      [theme]="theme"
      [gridOptions]="gridOptions"
      (cellClicked)="onCellClicked($event)"
    />
  </div>
</div>
